import { render, staticRenderFns } from "./IconSwitchHorizontalSolid.vue?vue&type=template&id=11ab7fb8"
import script from "./IconSwitchHorizontalSolid.vue?vue&type=script&lang=js"
export * from "./IconSwitchHorizontalSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports